/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.network.auth

import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.auth.auth

class SupabaseAuthTokenProvider(private val client: SupabaseClient) : AuthTokenProvider {

    override fun getIdToken(): String? {
        return client.auth.currentAccessTokenOrNull()
    }
}
